<template>
  <div v-if="show" class="auth-mask">
    <!-- 遮罩顶部logo和关闭 -->
    <div class="auth-topbar">
      <div class="flex items-center">
        <img :src="getAssetsFile('activity/2@2x (1).png')" alt="" class="h-[35px] w-auto ml-[5px]">
        <!-- <div class=" text-[15px] ml-[2px] fotnjian">Sure Win PH</div> -->
      </div>
      <Button type="close" class="relative z-[9000]" @click="closeAuthDialog"></Button>
      <!-- <img :src="getAssetsFile('home/zu16.png')" alt="" class="h-[27px] w-[27px]" @click="closeAuthDialog"> -->
    </div>

    <!-- 页面中间的 Loading -->
    <div v-if="isRegisterLoading || isLoginLoading" class="page-loading">
      <van-loading type="spinner" color="#17B663" />
    </div>
    <div class="auth-dialog-box">
      <!-- 底部弹窗 -->
      <div class="auth-dialog">
        <div class="auth-title">
          {{ isLogin ? t('authDialog.loginTitle') : t('authDialog.registerTitle') }}
        </div>
        <div class="auth-subtitle">
          <template v-if="isLogin">
            {{ t('authDialog.noAccount') }}
            <span class="auth-link" @click="openRegister">{{ t('authDialog.register') }}</span>
          </template>
          <template v-else>
            {{ t('authDialog.hasAccount') }}
            <span class="auth-link" @click="openLogin">{{ t('authDialog.signIn') }}</span>
            <div :style="{ backgroundImage: `url(${getAssetsFile('activity/8.png')})` }"
              class="text-[10px] ml-[5px] flex items-center px-[3px] justify-between w-[70px] h-[15px] bg-cover bg-no-repeat color-[#FDE077]"
              v-if="rewardStore.minShowReward > 0 || rewardStore.maxShowReward > 0">
              <div class="italic flex-shrink-0 ml-[6px]">{{ VITE_symbol }}</div>
              <div class="italic flex-shrink-0 whitespace-nowrap mr-[2px]">{{ rewardStore.minShowReward }}-{{
                rewardStore.maxShowReward }}</div>
            </div>
          </template>
        </div>
        <!-- <div class="auth-subtitle" style="color:#B3492D;font-size: 11px;margin-top:0;">
        O login expirou. Por favor, faça o login novamente
      </div> -->
        <div class="auth-form">
          <template v-if="isLogin">
            <div class="auth-input-row" :class="{ 'input-error': phoneError }">
              <img :src="getAssetsFile('home/yignud.png')" alt="" class="h-[20px] w-[20px]">
              <div class="color-white text-[13px] ml-[5px]">
                +{{ VITE_AREA_CODE }}
              </div>
              <div style="width: 0px;height: 32px;border:1px solid #416759;height:20px;margin-left:15px;" />
              <input v-model="loginForm.phone" class="auth-input   fontsetise" :placeholder="t('authDialog.phone')"
                @input="onPhoneInput" @keyup.enter="handleKeyup">
              <img v-if="loginForm.phone" :src="getAssetsFile('home/closes.png')" alt=""
                class="h-[11px] w-[11px] cursor-pointer" @click="loginForm.phone = ''">
            </div>
            <div v-if="phoneError" class="input-error-tip relative top-[5px] left-[0px]">
              <img :src="getAssetsFile('home/@2x.png')" alt="" class="h-[11px] w-[11px]">
              {{ t('authDialog.invalidPhone') }}
            </div>
            <div class="auth-input-row mt-[25px]">
              <img :src="getAssetsFile('home/yaoshi.png')" alt="" class="h-[14px] w-[14px]">
              <input v-model="loginForm.password" class="auth-input" :type="showLoginPassword ? 'text' : 'password'"
                :placeholder="t('authDialog.password')" @keyup.enter="handleKeyup">
              <img v-if="loginForm.password" :src="getAssetsFile('home/closes.png')" alt="" class="h-[12px] w-[12px]"
                @click="loginForm.password = ''" style="object-fit: contain;">
              <img v-if="showLoginPassword" :src="getAssetsFile('home/Preview@2x.png')" alt=""
                class="h-[14px] w-[14px] ml-[14px] cursor-pointer" style="object-fit: contain;"
                @click="toggleLoginPassword">
              <img v-if="!showLoginPassword" :src="getAssetsFile('home/Preview@2x (1).png')" alt=""
                class="h-[14px] w-[14px] ml-[14px] cursor-pointer" style="object-fit: contain;"
                @click="toggleLoginPassword">
            </div>
            <div class="auth-options mt-[22px]">
              <div class="remember-password-container" @click="toggleRememberPassword">
                <div class="custom-checkbox" :class="{ 'checked': rememberPassword }">
                  <img v-if="rememberPassword" :src="getAssetsFile('home/gouzhong.png')" alt="" class="check-icon">
                  <div v-else style="width:100%;height: 100%;border-radius: 3px;background: #FFF;"></div>
                </div>
                <span class="ml-[8px] text-[12px] color-[#ffffff] Lembrarstyle " style="">{{
                  t('authDialog.rememberPassword') }}</span>
              </div>
              <span class="auth-links" style="" @click="goToSecurity">{{ t('authDialog.forgotPassword') }}</span>
            </div>
            <div class="flex justify-center items-center">
              <Button type="medium" :disabled="isLoginLoading" @click="handleLogin">
                {{ t('authDialog.login') }}
              </Button>
            </div>

          </template>
          <template v-else>
            <!-- 注册表单 -->
            <div class="auth-input-row register-input" :class="{ 'input-error': registerPhoneError }">
              <img :src="getAssetsFile('home/yignud.png')" alt="" class="h-[20px] w-[20px]">
              <div class="color-white text-[13px] ml-[5px]">
                +{{ VITE_AREA_CODE }}
              </div>
              <div style="width: 0px;height: 32px;border:1px solid #416759;height:20px;margin-left: 5px;" />
              <input v-model="registerForm.phone" class="auth-input" :placeholder="t('authDialog.phone')"
                autocomplete="off" @input="onRegisterPhoneInput" @keyup.enter="handleKeyup">
              <img v-if="registerForm.phone" :src="getAssetsFile('home/closes.png')" alt=""
                class="h-[11px] w-[11px] cursor-pointer" @click="registerForm.phone = ''">
            </div>
            <div v-if="registerPhoneError" class="input-error-tip relative top-[5px] left-[0px]">
              <img :src="getAssetsFile('home/@2x.png')" alt="" class="h-[11px] w-[11px]">
              {{ t('authDialog.invalidPhone') }}
            </div>

          <!-- 验证码输入框 -->
          <div v-if="verifySwitch" class="auth-input-row register-input mt-[20px] verify-code-container">
            <img :src="getAssetsFile('activity/iphone.svg')" alt="" class="h-[20px] w-[20px]">
            <input
              v-model="registerForm.verifyCode"
              class="auth-input verify-code-input"
              :placeholder="t('authDialog.verifyCode')"
              autocomplete="off"
              @keyup.enter="handleKeyup"
            >
            <button
              class="verify-code-btn"
              :class="{ 'verify-code-btn-disabled': isSendingCode || countdown > 0 || !registerForm.phone || registerPhoneError }"
              :disabled="isSendingCode || countdown > 0 || !registerForm.phone || registerPhoneError"
              @click="sendVerifyCode"
            >
              {{ countdown > 0 ? `${countdown}s` : t('authDialog.getCode') }}
            </button>
          </div>

          <div class="auth-input-row register-input mt-[20px]">
            <img :src="getAssetsFile('home/yaoshi.png')" alt="" class="h-[15px] w-[15px]">
            <input
              v-model="registerForm.password"
              class="auth-input"
              :type="showRegisterPassword ? 'text' : 'password'"
              :placeholder="t('authDialog.password')"
              autocomplete="new-password"
              @input="onPasswordInput"
              @keyup.enter="handleKeyup"
            >
            <img
              v-if="registerForm.password"
              :src="getAssetsFile('home/closes.png')"
              alt=""
              class="h-[11px] w-[11px]"
              style="object-fit: contain;"
              @click="registerForm.password = ''"
            >
            <img
              v-if="showRegisterPassword"
              :src="getAssetsFile('home/Preview@2x.png')"
              alt=""
              class="h-[15px] w-[15px] ml-[10px] cursor-pointer"  style="object-fit: contain;"
              @click="toggleRegisterPassword"
            >
            <img
              v-if="!showRegisterPassword"
              :src="getAssetsFile('home/Preview@2x (1).png')"
              alt=""
              class="h-[15px] w-[15px] ml-[10px] cursor-pointer" style="object-fit: contain;"
              @click="toggleRegisterPassword"
            >
          </div>
          <div v-if="showPasswordTip" class="input-error-tip relative top-[5px] left-[0px]">
            <img :src="getAssetsFile('home/@2x.png')" alt="" class="h-[11px] w-[11px] mx-[1px] pt-[1px]">
            {{ t('authDialog.passwordLength') }}
          </div>
          <div class="auth-input-row register-input mt-[20px]">
            <img :src="getAssetsFile('home/yaoshi.png')" alt="" class="h-[15px] w-[15px]">
            <input
              v-model="registerForm.confirmPassword"
              class="auth-input"

              :type="showConfirmPassword ? 'text' : 'password'"
              :placeholder="t('authDialog.confirmPassword')"
              autocomplete="new-password"
              @keyup.enter="handleKeyup"
            >
            <img
              v-if="registerForm.confirmPassword"
              :src="getAssetsFile('home/closes.png')"
              alt=""
              class="h-[11px] w-[11px]"
              @click="registerForm.confirmPassword = ''"
            >
            <img
              v-if="showConfirmPassword"
              :src="getAssetsFile('home/Preview@2x.png')" style="object-fit: contain;"
              alt=""
              class="h-[15px] w-[15px] ml-[10px] cursor-pointer"
              @click="toggleConfirmPassword"
            >
            <img
              v-if="!showConfirmPassword"
              :src="getAssetsFile('home/Preview@2x (1).png')" style="object-fit: contain;"
              alt=""
              class="h-[15px] w-[15px] ml-[10px] cursor-pointer"
              @click="toggleConfirmPassword"
            >
          </div>

            <!-- CPF输入框 -->
            <div v-if="cpfSwitch" class="auth-input-row register-input mt-[20px]" :class="{ 'input-error': cpfError }">
              <img :src="getAssetsFile('activity/id-badge.svg')" alt="" class="h-[20px] w-[20px]">
              <input v-model="registerForm.cpf" class="auth-input" :placeholder="t('authDialog.cpf')" autocomplete="off"
                @input="onCpfInput" @keyup.enter="handleKeyup">
              <img v-if="registerForm.cpf" :src="getAssetsFile('home/closes.png')" alt=""
                class="h-[11px] w-[11px] cursor-pointer" @click="registerForm.cpf = ''">
            </div>
            <div v-if="cpfError" class="input-error-tip relative top-[5px] left-[0px]">
              <img :src="getAssetsFile('home/@2x.png')" alt="" class="h-[11px] w-[11px]">
              {{ t('authDialog.invalidCpf') }}
            </div>

            <!-- 注册按钮 -->
            <div class="register-button-container flex justify-center items-center">
              <Button type="medium" 
                :class="{ 'auth-btn-disabled': isRegisterDisabled }" :disabled="isRegisterDisabled"
                @click="handleRegister">
                {{ t('authDialog.registerBtn') }}
              </Button>
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>
<script setup lang="ts">
import { Button } from '@/components/Button'
import { computed, onMounted, onUnmounted, ref, watch, nextTick } from 'vue'
import { useUserStore } from '@/stores/modules/user'
import useUIStore from '@/stores/modules/ui'
import { useRewardStore } from '@/stores/modules/reward' // 添加奖励store导入
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { getAssetsFile } from '@/utils/pub-use'
import { APKTracking } from '@/utils/event-tracking'
import { trackHomeClickLoginButton, trackHomeClickRegisterButton } from '@/utils/firebase-analytics'
import { trackRegisterClick } from '@/utils/facebook-pixel-tracking'
import { showLoadingToast, closeToast } from 'vant' // 添加 Vant loading 导入

const router = useRouter()
const { t } = useI18n()
const VITE_AREA_CODE = import.meta.env.VITE_AREA_CODE
const VITE_symbol = import.meta.env.VITE_SYMBOL // 添加货币符号
import * as GameApi from '@/api/game'

const userStore = useUserStore()
const uiStore = useUIStore()
const rewardStore = useRewardStore() // 添加奖励store

// 从全局状态获取弹窗状态
const show = computed(() => uiStore.authDialog.show)
const isLogin = computed(() => uiStore.authDialog.isLogin)
const inviteCode = computed(() => uiStore.authDialog.inviteCode)
const getByNameData = ref({})

// 调用 getByName 接口
const callGetByName = async () => {
  try {
    const res = await GameApi.getByName()
    getByNameData.value = res.data
    console.log(res.data, 'res.data')
    verifySwitch.value = res.data?.verifySwitch || false
    cpfSwitch.value = res.data?.cpfSwitch || false
    console.log('getByName 接口返回:', getByNameData.value)
  } catch (error) {
    console.error('调用 getByName 接口失败:', error)
  }
}

// 发送验证码
const sendVerifyCode = async () => {
  if (isSendingCode.value || countdown.value > 0) return

  if (!registerForm.value.phone || registerPhoneError.value) {
    return
  }

  isSendingCode.value = true

  try {
    const data = {
      phone: registerForm.value.phone,
      areaCode: registerForm.value.areaCode,
    }
    await GameApi.sendVerifyCode(data)

    // 清除之前的定时器（如果存在）
    if (countdownTimer) {
      clearInterval(countdownTimer)
      countdownTimer = null
    }

    // 开始倒计时
    countdown.value = 60
    countdownTimer = setInterval(() => {
      countdown.value--
      if (countdown.value <= 0) {
        if (countdownTimer) {
          clearInterval(countdownTimer)
          countdownTimer = null
        }
      }
    }, 1000)

  } catch (error) {
    console.error('发送验证码失败:', error)
  } finally {
    isSendingCode.value = false
  }
}

// 验证码验证由后端接口处理，前端不做验证

function closeAuthDialog() {
  console.log('closeAuthDialog')
  uiStore.hideAuthDialog()
}

function openLogin() {
  uiStore.switchAuthMode(true)
  // 重置密码提示状态
  showPasswordTip.value = false
  // 延迟加载
  setTimeout(() => {
    loadRememberedCredentials()
  }, 300)
}

function openRegister() {
  uiStore.switchAuthMode(false)
}

async function handleLogin() {
  // 如果正在加载，直接返回
  if (isLoginLoading.value) {
    return
  }

  // 设置加载状态
  isLoginLoading.value = true

  trackHomeClickLoginButton()
  try {
    await userStore.login(loginForm.value)
    console.log('登录成功')

    // 登录成功后才处理记住密码的逻辑
    if (rememberPassword.value) {
      // 如果勾选了记住密码，保存账号密码
      saveRememberedCredentials()
    } else {
      // 如果没有勾选记住密码，清除本地存储
      localStorage.removeItem('rememberedCredentials')
    }

    uiStore.hideAuthDialog()
  }
  catch (error) {
    console.error('登录失败:', error)
  }
  finally {
    // 无论成功还是失败，都要重置加载状态
    isLoginLoading.value = false
  }
}

const loginForm = ref({
  phone: '',
  password: '',
  areaCode: VITE_AREA_CODE,
  platform: 1, // 默认为 Web(1)
})

// 添加注册表单
const registerForm = ref({
  phone: '',
  password: '',
  confirmPassword: '',
  verifyCode: '',
  cpf: '',
  areaCode: VITE_AREA_CODE,
  platform: 1,
})

// 添加密码显示状态
const showLoginPassword = ref(false)
const showRegisterPassword = ref(false)
const showConfirmPassword = ref(false)

// 添加记住密码状态
const rememberPassword = ref(true)

const phoneError = ref(false)
const registerPhoneError = ref(false)
const showPasswordTip = ref(false)

// 验证码相关状态
const verifySwitch = ref(false)
const countdown = ref(0)
const isSendingCode = ref(false)
let countdownTimer: NodeJS.Timeout | null = null // 保存倒计时定时器

// CPF相关状态
const cpfSwitch = ref(false)
const cpfError = ref(false)

// 计算属性：判断密码是否一致
const isPasswordMatch = computed(() => {
  return registerForm.value.password === registerForm.value.confirmPassword
    && registerForm.value.password.length > 0
    && registerForm.value.confirmPassword.length > 0
})

// 添加注册加载状态
const isRegisterLoading = ref(false)

// 添加登录加载状态
const isLoginLoading = ref(false)

// 计算属性：判断注册按钮是否可用
const isRegisterDisabled = computed(() => {
  const baseDisabled = !isPasswordMatch.value
    || registerForm.value.phone.length === 0
    || registerForm.value.password.length === 0
    || registerForm.value.confirmPassword.length === 0
    || isRegisterLoading.value // 添加加载状态检查

  // 如果需要验证码，检查验证码是否填写（验证由后端处理）
  if (verifySwitch.value) {
    return baseDisabled || registerForm.value.verifyCode.length === 0
  }

  // 如果需要CPF，检查CPF是否填写且有效
  if (cpfSwitch.value) {
    return baseDisabled || registerForm.value.cpf.length === 0 || cpfError.value
  }

  return baseDisabled
})

// 从本地存储加载记住的账号密码
function loadRememberedCredentials() {
  const remembered = localStorage.getItem('rememberedCredentials')
  console.log(remembered, 'remembered')
  if (remembered) {
    const credentials = JSON.parse(remembered)
    loginForm.value.phone = credentials.phone || ''
    loginForm.value.password = credentials.password || ''
    rememberPassword.value = true
  } else {
    // 如果没有保存的凭据，确保勾选框是未选中状态并清空输入框
    rememberPassword.value = false
    loginForm.value.phone = ''
    loginForm.value.password = ''
  }
}

// 保存记住的账号密码
function saveRememberedCredentials() {
  if (rememberPassword.value) {
    const credentials = {
      phone: loginForm.value.phone,
      password: loginForm.value.password,
    }
    localStorage.setItem('rememberedCredentials', JSON.stringify(credentials))
  }
  else {
    localStorage.removeItem('rememberedCredentials')
  }
}

// 切换记住密码状态
function toggleRememberPassword() {
  rememberPassword.value = !rememberPassword.value
  // 移除立即清空输入框的逻辑
  // 只在登录成功后才决定是否保存
}

function onPhoneInput(e: Event) {
  const val = (e.target as HTMLInputElement).value.replace(/\D/g, '')
  // 限制最多11位数字
  const limitedVal = val.slice(0, 11)
  loginForm.value.phone = limitedVal
  phoneError.value = !/^\d{11}$/.test(limitedVal) // 必须是11位数字
}

// 添加注册手机号输入处理
function onRegisterPhoneInput(e: Event) {
  const val = (e.target as HTMLInputElement).value.replace(/\D/g, '')
  // 限制最多11位数字
  const limitedVal = val.slice(0, 11)
  registerForm.value.phone = limitedVal
  registerPhoneError.value = !/^\d{11}$/.test(limitedVal) // 必须是11位数字
}

// 添加CPF输入处理
function onCpfInput(e: Event) {
  const val = (e.target as HTMLInputElement).value.replace(/\D/g, '')
  registerForm.value.cpf = val
  // CPF必须是11位数字且通过验证算法
  cpfError.value = val.length > 0 && (val.length !== 11 || !isValidCPF(val))
}

// 巴西CPF验证算法
function isValidCPF(cpf: string): boolean {
  // 移除所有非数字字符
  cpf = cpf.replace(/\D/g, '')

  // 检查长度
  if (cpf.length !== 11) return false

  // 检查是否所有数字都相同 (如: 111.111.111-11)
  if (/^(\d)\1{10}$/.test(cpf)) return false

  // 验证第一个校验位
  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i)
  }
  let remainder = sum % 11
  let firstDigit = remainder < 2 ? 0 : 11 - remainder

  if (parseInt(cpf.charAt(9)) !== firstDigit) return false

  // 验证第二个校验位
  sum = 0
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i)
  }
  remainder = sum % 11
  let secondDigit = remainder < 2 ? 0 : 11 - remainder

  return parseInt(cpf.charAt(10)) === secondDigit
}

// 添加密码输入处理
function onPasswordInput() {
  const passwordLength = registerForm.value.password.length
  // 当密码长度达到6位或以上时隐藏提示
  showPasswordTip.value = passwordLength > 0 && passwordLength < 6
}

// 切换密码显示状态
function toggleLoginPassword() {
  showLoginPassword.value = !showLoginPassword.value
}

function toggleRegisterPassword() {
  showRegisterPassword.value = !showRegisterPassword.value
}

function toggleConfirmPassword() {
  showConfirmPassword.value = !showConfirmPassword.value
}

// 添加键盘事件处理函数
function handleKeyup(event: KeyboardEvent) {
  if (event.key === 'Enter') {
    if (isLogin.value) {
      handleLogin()
    } else {
      handleRegister()
    }
  }
}

// 监听弹窗显示状态，控制背景滚动
watch(() => show.value, (newVal) => {
  if (newVal) {
    document.body.style.overflow = 'hidden'
    // 弹窗打开时调用 getByName 接口
    callGetByName()
    // 延迟加载，让浏览器自动填充先完成
    if (isLogin.value) {
      setTimeout(() => {
        loadRememberedCredentials()
      }, 300) // 延迟300ms
    }
  }
  else {
    document.body.style.overflow = 'auto'
  }
})

async function handleRegister() {
  // 如果按钮被禁用或正在加载，直接返回
  if (isRegisterDisabled.value || isRegisterLoading.value) {
    return
  }

  // 设置加载状态
  isRegisterLoading.value = true

  try {
    // 上报点击注册按钮事件
    const apkTracking = new APKTracking()
    apkTracking.trackRegisterClick()
    const adjustTracking = window.$adjustTracking
    if (adjustTracking) {
      adjustTracking.trackRegisterClick()
    }
    const appsFlyerTracking = window.$appsFlyerTracking
    if (appsFlyerTracking) {
      appsFlyerTracking.trackRegisterClick()
    }
    // 上报 Facebook Pixel 注册点击事件
    trackRegisterClick()
    trackHomeClickRegisterButton()

    // 只提交后端需要的字段
    const submitData = {
      phone: registerForm.value.phone,
      password: registerForm.value.password,
      areaCode: registerForm.value.areaCode,
      platform: registerForm.value.platform,
      promoter: false,
      ...(inviteCode.value && { inviteCode: inviteCode.value }),
      phoneVerifyCode: registerForm.value.verifyCode || '',
      cpf: registerForm.value.cpf || ''
    }

    await userStore.register(submitData)
    console.log('注册并登录成功')

    // 设置新用户标记，用于跳转到转盘页面
    sessionStorage.setItem('isNewUser', 'true')

    uiStore.hideAuthDialog()

    // 使用 nextTick 确保状态更新后再检查
    await nextTick()
    // 移除直接跳转逻辑，让首页的 checkNewUserTurntableStatus 函数来处理
    // 这样可以确保在跳转前检查活动状态

    // 清空注册表单
    registerForm.value.phone = ''
    registerForm.value.password = ''
    registerForm.value.confirmPassword = ''
    registerForm.value.verifyCode = ''
    registerForm.value.cpf = ''
    showPasswordTip.value = false
  }
  catch (error) {
    console.error('注册失败:', error)
  }
  finally {
    // 无论成功还是失败，都要重置加载状态
    isRegisterLoading.value = false
  }
}

function goToSecurity() {
  // 关闭弹窗
  uiStore.hideAuthDialog()
  // 跳转到安全页面
  router.push({ name: 'mensagens' })
}

// 组件卸载时也要恢复滚动并清除定时器
onUnmounted(() => {
  document.body.style.overflow = 'auto'
  // 清除倒计时定时器
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null
  }
})

// 组件加载时加载记住的密码
onMounted(() => {
  loadRememberedCredentials()
})
</script>



<style scoped>
input::placeholder {
  color: #34B388;
  font-size: 13px;
}

/* 浏览器自动填充样式覆盖 */
.auth-input:-webkit-autofill,
.auth-input:-webkit-autofill:hover,
.auth-input:-webkit-autofill:focus,
.auth-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #11412f inset !important;
  -webkit-text-fill-color: #fff !important;
  transition: background-color 5000s ease-in-out 0s;
  background-color: #003C31 !important;
}

/* Firefox 自动填充样式 */
.auth-input:-moz-autofill {
  background-color: #11412f !important;
  color: #fff !important;
}

/* 确保自动填充后的输入框保持原有样式 */
.auth-input:autofill {
  background-color: #11412f !important;
  color: #fff !important;
}

.auth-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  /* 降级背景 */
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

/* 为不支持 backdrop-filter 的浏览器提供降级 */
@supports not (backdrop-filter: blur(10px)) {
  .auth-mask {
    background: rgba(0, 0, 0, 0.8);
    /* 更深的背景作为降级 */
  }
}

.auth-topbar {
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  padding: 12px 18px 0 20px;
  /* pointer-events: none; */
}

/* 单独给关闭按钮设置可点击 */
.auth-topbar img:last-child {
  pointer-events: auto;
  cursor: pointer;
}

.auth-logo-img {
  width: 120px;
  height: 36px;
  background: transparent;
  /* 这里可放logo图片 */
  pointer-events: auto;
}

.auth-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  padding: 0;
  pointer-events: auto;
}

.auth-dialog-box {
  width: 100vw;
  height: 85%;
  border-radius: 24px 24px 0 0;
  padding: 2px 0 0 0;
  background: linear-gradient(0deg, #FFBF2F, #E6C32C);
  animation: slideUp 0.3s;
}

.auth-dialog {
  width: 100%;
  height: 100%;
  background: #00554A;

  border-radius: 24px 24px 0 0;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.18);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 999999;
  /* 提高z-index */
  padding-bottom: 32px;

}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

.Lembrarstyle {
  font-size: 12px;
}

.auth-title {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin: 25px 24px 0 24px;
}

.auth-subtitle {
  margin: 3px 24px 0 24px;
  color: #fff;
  font-size: 15px;
  display: flex;
  align-items: center;
}

.auth-link {
  color: #EEF93B;
  font-weight: bold;
  margin-left: 4px;
  font-size: 13px;
  cursor: pointer;
}

.auth-links {
  margin-left: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #FFF;
  font-weight: 400;
}

@media (max-width: 480px) {
  .auth-links {
    font-size: 13px !important;
  }
}

.auth-error {
  color: #ff4d4f;
  font-size: 13px;
  margin: 8px 24px 0 24px;
}

.auth-form {
  margin: 32px 24px 0 24px;
}

.auth-input-row {
  display: flex;
  box-shadow: inset 0px 2px 1px 0px rgba(0, 28, 24, 0.66);
  /* border: 1px solid #50d38c; */
  border-radius: 3px 3px 3px 3px;
  align-items: center;
  background: #11412f;
  display: flex;
  align-items: center;
  padding: 0 11px;
}

/* 添加注册页面的边框颜色 */
.auth-dialog:has(.auth-form > template:last-child) .auth-input-row,
.auth-dialog .auth-form>template:last-child .auth-input-row {
  border-color: #009F76;
}

/* 或者更简单的方式，直接为注册表单的输入框设置样式 */
.auth-input-row.register-input {
  border-color: #009F76;
}

.auth-img-placeholder {
  width: 28px;
  height: 28px;
  background: #1a4d3a;
  border-radius: 6px;
  margin-right: 8px;
}

.auth-input {
  flex: 1;
  height: 40px;
  border-radius: 8px;
  border: none;
  padding: 0 12px;
  background: none;
  color: #fff;
  font-size: 15px;
  caret-color: #50d38c;
}

@media (min-width: 750px) {
  .auth-input {
    font-size: 12px !important;
  }
}

.auth-code-btn {
  margin-left: 8px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: #3cc35f;
  color: #fff;
  font-size: 13px;
  padding: 0 12px;
  cursor: pointer;
}

.auth-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  color: #fff;
  font-size: 13px;
}

.auth-btn {
  width: 100%;
  height: 44px;
  background: #17B663;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 20px;
}

input[type='checkbox'] {
  accent-color: #50d38c;
}

.input-error {
  border: 1px solid #ff4d4f !important;
}

.input-error-tip {
  display: flex;
  align-items: baseline;
  color: #ff4d4f;
  font-size: 13px;
}

.input-tip {
  display: flex;
  align-items: baseline;
  color: #50d38c;
  font-size: 13px;
}

.auth-btn-disabled {
  background: linear-gradient(180deg, #116A38 0%, #136134 100%);
  cursor: not-allowed !important;
  font-size: 13px !important;
  margin-top: 20px;
}

/* 移动端样式 */
@media (max-width: 480px) {
  .auth-btn-disabled {
    margin-top: 20px !important;
  }
}

/* 平板端样式 */
@media (min-width: 481px) and (max-width: 780px) {
  .auth-btn-disabled {
    margin-top: 20px !important;
  }
}

.auth-btn:disabled {
  background: linear-gradient(180deg, #116A38 0%, #136134 100%);
  cursor: not-allowed !important;
}

.fotnjian {
  background: linear-gradient(180deg, #0152B9 50%, #298A4E 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
}

.remember-password-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.remember-password-container:hover {
  opacity: 0.8;
}

.custom-checkbox {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: relative;
}

.check-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.remember-password-container:hover .custom-checkbox {
  border-color: #3cc35f;
  transform: scale(1.05);
}

.register-button-container {
  margin-top: 33px;
}

.register-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  border: 1px solid #009F76;
  height: 44px;
  /* 与按钮高度一致 */
}

/* 页面中间的 Loading */
.page-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;
  /* 确保在弹窗之上 */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 20px;
}

/* 确保弹窗层级 */
.auth-dialog {
  z-index: 10000;
}

.auth-mask {
  z-index: 9999;
}

/* 验证码按钮样式 */
.verify-code-btn {
  background: none;
  border: none;
  color: #34B388;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: #34B388;
  text-underline-offset: 2px;
  padding: 0;
  margin-left: 8px;
  white-space: nowrap;
  min-width: 50px;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
}

.verify-code-btn:hover {
  color: #2a9a73;
}

.verify-code-btn-disabled {
  color: #666 !important;
  cursor: not-allowed !important;
  text-decoration: none !important;
}

/* 验证码容器样式 */
.verify-code-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.verify-code-input {
  flex: 1;
  min-width: 0;
  /* 允许输入框收缩 */
}
</style>
